export const getFormatedDate = (isoDate: string, locale = 'pl-PL'): string =>
    new Date(isoDate).toLocaleDateString(locale, {
        day: '2-digit',
        month: '2-digit',
    })

export const getDayOfWeek = (isoDate: string, locale = 'pl-PL'): string =>
    new Date(isoDate).toLocaleDateString(locale, {
        weekday: 'long',
    })

export const getTimeSlot = (timeSlot: string, locale = 'pl-PL'): string =>
    new Date(timeSlot).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    })
